import React from 'react';
import { Input } from '@/components/ui/input';

export const normalizeCode = (value, useBackup) => (useBackup
  ? value.replace(/[^A-Za-z0-9-]/g, '').toUpperCase().slice(0, 9)
  : value.replace(/\D/g, '').slice(0, 6));

export default function CodeInput({ code, onChange, useBackup = false }) {
  return (
    <Input
      value={code}
      onChange={(e) => onChange(normalizeCode(e.target.value, useBackup))}
      placeholder={useBackup ? 'XXXX-XXXX' : '000000'}
      inputMode={useBackup ? 'text' : 'numeric'}
      autoComplete="one-time-code"
      autoFocus
      className="text-center text-2xl tracking-[0.4em] font-mono h-14"
      data-testid="totp-code-input"
    />
  );
}
